export default __webpack_public_path__ + "static/media/manzil-stack4.webp";